module.exports = __webpack_public_path__ + "img/platform.576caf53.png";